function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/* eslint-disable react/forbid-prop-types */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Accordion } from 'semantic-ui-react';
import CollectionTreeItem from "./CollectionTreeItem";
import { getRest } from "../../utils";

/**
 * Collection Tree.
 *
 * @class CollectionTree
 * @extends {React.Component}
 */
import { jsx as _jsx } from "react/jsx-runtime";
var CollectionTree = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CollectionTree, _React$Component);
  function CollectionTree() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    /**
       * Return array with/without index.
       *
       * @memberof CollectionTree
       */
    _this.computeNewIndex = function (index) {
      var active = _this.state.active;
      return _.includes(active, index) ? _.without(active, index) : [].concat(active, [index]);
    };
    /**
       * Handle click on accordion title.
       *
       * @memberof CollectionTree
       */
    _this.handleClick = function (index) {
      _this.setState({
        active: _this.computeNewIndex(index)
      }, function () {
        _.invoke(_this.props, 'onAccordionClick', index, _this.isIndexActive(index));
      });
    };
    _this.updateDefaultActive = function () {
      var items = _this.props.items;
      _this.setState({
        active: [].concat(Array.from(Array(items == null ? void 0 : items.length).keys()))
      });
    };
    /**
       * Is index active.
       *
       * @memberof CollectionTree
       */
    _this.isIndexActive = function (index) {
      var active = _this.state.active;
      return _.includes(active, index);
    };
    _this.state = {
      /** Indexes of opened items. */
      active: []
    };
    return _this;
  }

  /**
     *
     * @memberof CollectionTree
     */
  var _proto = CollectionTree.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      defaultActiveIndexes = _this$props.defaultActiveIndexes,
      defaultActive = _this$props.defaultActive;
    if (!_.isNil(defaultActiveIndexes)) {
      this.setState({
        active: defaultActiveIndexes
      });
    }
    if (defaultActive) {
      this.updateDefaultActive();
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
      defaultActive = _this$props2.defaultActive,
      items = _this$props2.items;
    if (defaultActive && (prevProps == null ? void 0 : prevProps.items) !== items) {
      this.updateDefaultActive();
    }
  };
  /**
     * Render the component.
     *
     * @returns
     * @memberof CollectionTree
     */
  _proto.render = function render() {
    var _this2 = this;
    var _this$props3 = this.props,
      items = _this$props3.items,
      onItemCreate = _this$props3.onItemCreate;
    var rest = getRest(CollectionTree, this.props);
    return /*#__PURE__*/_jsx(Accordion, Object.assign({}, rest, {
      fluid: true,
      children: _.map(items, function (item, index) {
        return /*#__PURE__*/_jsx(CollectionTreeItem, {
          index: index,
          item: item,
          active: _this2.isIndexActive(index),
          onClick: _this2.handleClick,
          onItemCreate: onItemCreate
        }, "treeItem" + item.title);
      })
    }));
  };
  return CollectionTree;
}(React.Component);
/**
 * PropTypes.
 */
CollectionTree.handledProps = ["defaultActive", "defaultActiveIndexes", "items", "onAccordionClick", "onItemCreate"];
CollectionTree.propTypes = {
  /** Array of results. */
  items: PropTypes.array,
  /** Indexes of accordion active. */
  defaultActiveIndexes: PropTypes.array,
  /** Func on accordion click. */
  onAccordionClick: PropTypes.func,
  /** Func on item create. */
  onItemCreate: PropTypes.func,
  /** Accordion always open */
  defaultActive: PropTypes.bool
};
export default CollectionTree;